import styled from "styled-components";
import { Column } from "../Grid";

export const Card = styled(Column)`
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  box-sizing: border-box;
`;
